import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const onGetPlaylistByID = (ID) => Axios.get(`/playlists/${ID}`);

const usePlaylist = (ID) => {
    return useQuery({
        queryKey: ['playlist', ID],
        queryFn: () => onGetPlaylistByID(ID),
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
        enabled: ID ? true : false,
    });
};

const forceReloadPlaylist = (ID) => {
    queryClient.invalidateQueries({ queryKey: ['playlist', ID] });
};

const onGetPlaylistPackages = (ID) => Axios.get(`/playlists/packages/${ID}`);

const usePlaylistPackages = (ID) => {
    return useQuery({
        queryKey: ['playlist-packages', ID],
        queryFn: () => onGetPlaylistPackages(ID),
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
        enabled: ID ? true : false,
    });
};

const onGetPlaylistLastPackages = (ID) => Axios.get(`/playlists/lastpackages/${ID}/6`);

const usePlaylistLastPackages = (ID) => {
    return useQuery({
        queryKey: ['playlist-last-packages', ID],
        queryFn: () => onGetPlaylistLastPackages(ID),
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
        enabled: ID ? true : false,
    });
};

const onGetPlaylistInfo = (ID) => Axios.get(`/playlists/info/${ID}`);

const usePlaylistInfo = (ID) => {
    return useQuery({
        queryKey: ['playlist-info', ID],
        queryFn: () => onGetPlaylistInfo(ID),
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
        enabled: ID ? true : false,
    });
};

const forceReloadPlaylistInfo = (ID) => {
    queryClient.invalidateQueries({ queryKey: ['playlist-info', ID] });
};

const onGetPlaylistPreview = (ID) => Axios.get(`/playlists/preview/${ID}`);

const usePlaylistPreview = (ID) => {
    return useQuery({
        queryKey: ['playlist-preview', ID],
        queryFn: () => onGetPlaylistPreview(ID),
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
        enabled: ID ? true : false,
    });
};

export {
    usePlaylist,
    usePlaylistInfo,
    usePlaylistPreview,
    forceReloadPlaylist,
    forceReloadPlaylistInfo,
    usePlaylistPackages,
    usePlaylistLastPackages,
};
